import { gqlProfileStatusEnum as PROFILE_STATUS } from '@minecraft.graphql-types';

const StatusesForRedirect = [
  PROFILE_STATUS.VERIFY_AGE,
  PROFILE_STATUS.CREATE_PROFILE_STEP_1,
  PROFILE_STATUS.CREATE_PROFILE_STEP_2,
  PROFILE_STATUS.CREATE_PROFILE_STEP_3,
  PROFILE_STATUS.CREATE_PROFILE_STEP_4,
  PROFILE_STATUS.SELECT_MEMBERSHIP,
];

export default StatusesForRedirect;
